import './style.scss';
import DialogTitle from "@material-ui/core/DialogTitle";
import ReportsIcon from "@material-ui/icons/DescriptionRounded";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";
import Dialog from "@material-ui/core/Dialog";
import React, {useEffect, useState} from "react";
import axios from "axios";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import {EnhancedTableHead} from "../../../Utils/TableUtils/EnhancedTableHead";
import TableBody from "@material-ui/core/TableBody";
import {getComparator, stableSort} from "../../../Utils/TableUtils/Functions";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import moment from "moment";
import DeleteIcon from "@material-ui/icons/DeleteRounded";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import SaveIcon from "@material-ui/icons/SaveRounded";
import uuid from "uuid";

const manualChangesHeadCells = [
    {id: 'inputAddress', label: 'כתובת נכנסת'},
    {id: 'formattedAddress', label: 'כתובת חדשה'},
    {id: 'timestamp', label: 'זמן שמירה'}
];

const manualRecommendationsHeadCells = [
    {id: 'inputAddress', label: 'כתובת נכנסת'},
    {id: 'formattedAddress', label: 'כתובת חדשה'},
    {id: 'count', label: 'מספר שינויים'}
];

export default function AddressManualChangesDialog({
                                                       open = false,
                                                       match,
                                                       onClose,
                                                       minAddressChangeRecommendationDialog
                                                   }) {
    const [manualChanges, setManualChanges] = useState();
    const [manualRecommendations, setManualRecommendations] = useState();
    const [changesOrder, setChangesOrder] = useState('asc');
    const [changesOrderBy, setChangesOrderBy] = useState('timestamp');
    const [recommendationsOrder, setRecommendationsOrder] = useState('asc');
    const [recommendationsOrderBy, setRecommendationsOrderBy] = useState('count');

    async function initManualChanges() {
        const {data: manualChangesResult} = await axios.get('/api/v2/addressCache/', {
            params: {
                bid: match.params.bid,
                saveTypes: "MANUAL"
            }
        });

        if (manualChangesResult.found) {
            for (let r of manualChangesResult.results)
                r.id = uuid.v4();

            setManualChanges(manualChangesResult.results);
        } else
            setManualChanges([]);
    }

    async function initManualRecommendations() {
        const {data: manualRecommendationsResult} = await axios.get('/api/v2/addressCache/manualRecommendations', {
            params: {
                bid: match.params.bid,
                minimumCount: minAddressChangeRecommendationDialog
            }
        });

        for (let r of manualRecommendationsResult)
            r.id = uuid.v4();

        setManualRecommendations(manualRecommendationsResult);
    }

    useEffect(() => {
        if (open) {
            setManualChanges(null);
            setManualRecommendations(null);

            initManualChanges();
            initManualRecommendations();
        }
    }, [open]);

    function onManualChangesRequestSort(event, property) {
        setChangesOrder(changesOrderBy === property && changesOrder === 'desc' ? 'asc' : 'desc');
        setChangesOrderBy(property);
    }

    function onManualRecommendationsRequestSort(event, property) {
        setRecommendationsOrder(recommendationsOrderBy === property && recommendationsOrder === 'desc' ? 'asc' : 'desc');
        setRecommendationsOrderBy(property);
    }

    async function handleRemoveManualChange(address) {
        await axios.delete('/api/v2/addressCache/', {
            params: {
                bid: match.params.bid,
                address: address
            }
        });

        initManualChanges();
        initManualRecommendations();
    }

    async function handleSaveManualChange(inputAddress, currentAddress) {
        await axios.post('/api/v2/addressCache/', {
            bid: match.params.bid,
            address: inputAddress,
            formattedAddress: currentAddress.address + ", ישראל",
            location: currentAddress.location,
            placeId: currentAddress.placeId
        });

        initManualChanges();
        initManualRecommendations();
    }

    return <Dialog
        scroll={'paper'}
        className="address-manual-changes-dialog"
        open={open}
        onClose={onClose}
        PaperProps={{className: "address-manual-changes-dialog-paper"}}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
            <div className="address-manual-changes-dialog-title-content">
                <ReportsIcon style={{"fontSize": "32px"}}/>
                &nbsp;
                שינויי כתובות
            </div>
        </DialogTitle>
        <DialogContent dividers={true} className="dialog-content">
            <div className="dialog-real-content">
                {
                    manualChanges === null || manualChanges === undefined ||
                    manualRecommendations == null || manualRecommendations === undefined ?
                        <div className="loader-container">
                            <CircularProgress size={80} thickness={2}/>
                        </div>
                        :
                        <React.Fragment>
                            <div className="address-manual-changes">
                                {
                                    manualChanges.length ?
                                        <React.Fragment>
                                            <div className="address-manual-changes-table-title">
                                                שינויי כתובות שמורים:
                                            </div>
                                            <TableContainer className="address-manual-changes-table" component={Paper}>
                                                <Table stickyHeader aria-label="simple table">
                                                    <EnhancedTableHead
                                                        headCells={manualChangesHeadCells}
                                                        order={changesOrder}
                                                        orderBy={changesOrderBy}
                                                        onRequestSort={onManualChangesRequestSort}
                                                        includeDeleteCell={false}
                                                    />
                                                    <TableBody>
                                                        {
                                                            stableSort(manualChanges,
                                                                getComparator({
                                                                    "asc": "desc",
                                                                    "desc": "asc"
                                                                }[changesOrder], changesOrderBy)).map(row => (
                                                                <TableRow className="address-manual-change-table-row"
                                                                          key={row.id}>
                                                                    <TableCell>
                                                                        <div className="input-address-cell">
                                                                            <IconButton
                                                                                className="remove-manual-change-button"
                                                                                onClick={() => handleRemoveManualChange(row.address)}>
                                                                                <DeleteIcon fontSize="small"/>
                                                                            </IconButton>
                                                                            {row.address.replaceAll(".*", "*")}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>{row.formattedAddress}</TableCell>
                                                                    <TableCell className="timestamp-cell">
                                                                        {moment(row.timestamp).format('DD/MM/YYYY, HH:mm')}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </React.Fragment>
                                        :
                                        <div className="address-manual-changes-table-title">
                                            אין שינויי כתובות שמורים
                                        </div>
                                }
                            </div>
                            <div className="manual-saved-recommended-separator"/>
                            <div className="address-manual-recommendations">
                                {
                                    manualRecommendations.length ?
                                        <React.Fragment>
                                            <div className="address-manual-recommendations-table-title">
                                                שינויי כתובות מומלצים:
                                            </div>
                                            <TableContainer className="address-manual-recommendations-table"
                                                            component={Paper}>
                                                <Table stickyHeader aria-label="simple table">
                                                    <EnhancedTableHead
                                                        headCells={manualRecommendationsHeadCells}
                                                        order={recommendationsOrder}
                                                        orderBy={recommendationsOrderBy}
                                                        onRequestSort={onManualRecommendationsRequestSort}
                                                        includeDeleteCell={false}
                                                    />
                                                    <TableBody>
                                                        {
                                                            stableSort(manualRecommendations,
                                                                getComparator({
                                                                    "asc": "desc",
                                                                    "desc": "asc"
                                                                }[recommendationsOrder], recommendationsOrderBy)).map(row => (
                                                                <TableRow
                                                                    className="address-manual-recommendation-table-row"
                                                                    key={row.id}>
                                                                    <TableCell>
                                                                        <div className="input-address-cell">
                                                                            <IconButton
                                                                                className="save-manual-change-button"
                                                                                onClick={() => handleSaveManualChange(row.inputAddress, row.currentAddress)}>
                                                                                <SaveIcon fontSize="small"/>
                                                                            </IconButton>
                                                                            {row.inputAddress}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>{row.currentAddress.address}</TableCell>
                                                                    <TableCell>{row.count}</TableCell>
                                                                </TableRow>
                                                            ))
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </React.Fragment>
                                        :
                                        <div className="address-manual-recommendations-table-title">
                                            אין שינויי כתובות להמלצה
                                        </div>
                                }
                            </div>
                        </React.Fragment>
                }
            </div>
            <div className="dialog-actions">
                <IconButton className="close-button"
                            onClick={onClose}>
                    <CloseIcon fontSize="small"/>
                </IconButton>
            </div>
        </DialogContent>
    </Dialog>
}